import { produce } from 'immer';
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import type { UserInfo } from '@/chat-types/model/UserInfo';
import { KEY } from '@/consts/keys';

interface AuthState {
  isLogin: boolean;
  userInfo?: UserInfo;
  saveUser: (id: UserInfo) => void;
  logout: () => void;
}

const useAuthStore = create<AuthState>()(
  devtools(
    persist(
      (set) => ({
        isLogin: false,
        userInfo: undefined,
        saveUser: (user) => {
          set(
            produce((draft: AuthState) => {
              draft.userInfo = user;
            }),
          );
        },
        logout: () => {
          set(
            produce((draft: AuthState) => {
              draft.userInfo = undefined;
            }),
          );
          localStorage.removeItem(KEY.API_ID);
          localStorage.removeItem(KEY.CLIENT_ID);
        },
      }),
      { name: 'LOGIN_AUTH_KEY' },
    ),
  ),
);

export default useAuthStore;
